export class UnauthorizedError extends Error {
  static {
    UnauthorizedError.prototype.name = "UnauthorizedError"
  }

  constructor(options?: ErrorOptions) {
    super("unauthorized", options)
  }
}

export class ForbiddenError extends Error {
  static {
    ForbiddenError.prototype.name = "ForbiddenError"
  }

  constructor(options?: ErrorOptions) {
    super("forbidden", options)
  }
}

export class NotFoundError extends Error {
  static {
    NotFoundError.prototype.name = "NotFoundError"
  }

  constructor(options?: ErrorOptions) {
    super("resource not found", options)
  }
}

export class UnknownError extends Error {
  static {
    UnknownError.prototype.name = "UnknownError"
  }

  constructor(options?: ErrorOptions) {
    super("unknown", options)
  }
}

abstract class AuthError extends Error {}

export class InvalidCredentialError extends AuthError {
  static {
    InvalidCredentialError.prototype.name = "InvalidCredentialError"
  }

  constructor(options?: ErrorOptions) {
    super("invalid credential", options)
  }
}

export class EmailAlreadyInUseError extends AuthError {
  static {
    EmailAlreadyInUseError.prototype.name = "EmailAlreadyInUseError"
  }

  constructor(options?: ErrorOptions) {
    super("email already in use", options)
  }
}

export class AccountExistsWithDifferentCredentialError extends AuthError {
  static {
    AccountExistsWithDifferentCredentialError.prototype.name =
      "AccountExistsWithDifferentCredentialError"
  }

  constructor(options?: ErrorOptions) {
    super("already logged in with different credentials", options)
  }
}
